import { render } from "./RequirementAttachmentMediaImage.vue?vue&type=template&id=cba79ef8&scoped=true"
import script from "./RequirementAttachmentMediaImage.vue?vue&type=script&lang=js"
export * from "./RequirementAttachmentMediaImage.vue?vue&type=script&lang=js"

import "./RequirementAttachmentMediaImage.vue?vue&type=style&index=0&id=cba79ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba79ef8"]])

export default __exports__